import { createFileRoute } from "@tanstack/react-router";

import { SKUStoreMediaPage } from "@/features/SKUStore/SKUStoreMediaPage";

export const Route = createFileRoute("/_auth/sku-store/$siteId/$skuId/media")({
  component: SKUStoreMediaPage,
});
